/**
 * Maps login/auth API `message` strings to i18n keys for Arabic and other locales.
 */
const AUTH_API_MESSAGE_TO_KEY = {
  "Your account is under review. We will contact you soon.": "auth.login.accountUnderReview",
  "Your account is inactive. Please contact support@loops.sa.": "auth.login.accountInactive",
  "Invalid credentials": "auth.login.invalidCredentials",
  "The restaurant account is under review. Please contact your administrator.":
    "auth.login.restaurantUnderReview",
  "The restaurant account is inactive. Please contact your administrator or support@loops.sa.":
    "auth.login.restaurantInactive",
  "Your account cannot sign in. Please contact support@loops.sa.": "auth.login.cannotSignIn",
  "Please verify your email before logging in. Check your inbox for the verification link.":
    "auth.login.emailNotVerified",
  "Email verified successfully. You can now log in.": "verifyEmail.success",
  "Invalid or expired verification link. Please request a new one.": "verifyEmail.expired",
  "Verification token is required.": "verifyEmail.tokenRequired",
  "If an account exists for this email, a verification link has been sent.": "verifyEmail.resent",
  "This email is already verified. You can log in.": "verifyEmail.alreadyVerified",
  "Failed to send verification email. Please try again later.": "verifyEmail.sendFailed",
  "Email is required.": "verifyEmail.emailRequired",
};

/**
 * @param {unknown} message - `err.response?.data?.message`
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateAuthApiMessage(message, t) {
  if (message == null || message === "") return "";
  const s = String(message).trim();
  const key = AUTH_API_MESSAGE_TO_KEY[s];
  if (key) return t(key);
  return t(s, { defaultValue: s });
}
